// Copyright (c) Docugami, Inc. All rights reserved.

import { emptyGray } from 'components/shell/presentation/AppStyles'
import { TooltipHost } from "@fluentui/react"
import styled from 'styled-components'

const Icon = styled.div<{color: string, size: number}>`
    border-radius: ${props => props.size}px;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    border: 1px solid ${emptyGray};
    background: ${props => props.color};
`

interface StatusIconProps {
    color: string,
    size: number,
    tooltip?: string
}

export const StatusIcon = (props: StatusIconProps): JSX.Element => {
    return (
        <TooltipHost content={props.tooltip}>
            <Icon color={props.color} size={props.size} />
        </TooltipHost>
    );
}
